export default __webpack_public_path__ + "static/media/octavio_ordaz.44e6879d.jpeg";